import {
  FILTER_FIELDS_TYPES,
  FILTER_OPERATOR_ENUMS,
  FILTER_RULE_ENUMS,
} from '@constants';
import { formatDate, timeFromNow } from '@utils';
import { computeValueByRuleType } from 'components/common/modals/FiltersModalV2/utils';
import {
  CONTRACTS_FIELDS_MAPPER,
  CONTRACTS_DATE_FORMAT,
} from 'components/subscriptionContracts/constants';
import { isValid } from 'date-fns';
import { omit } from 'lodash-es';

export const CONTRACTS_EXPORT_LIMIT = 100000;

export const getSubscriptionContractsPayload = (payload = {}) => {
  const fields =
    omit(payload, [
      'page',
      'dateFrom',
      'dateTo',
      'pageSize',
      'order',
      'orderBy',
      'query',
    ]) || {};

  const fieldsMap = {
    status: 'meta.status',
  };
  const getValueField = ({ field }) => {
    return payload[field];
  };
  const getType = () => {
    return FILTER_RULE_ENUMS.ComparableRuleType;
  };
  const rules = [...Object.keys(fields)].map((field) => ({
    field: fieldsMap[field] || field,
    operator: FILTER_OPERATOR_ENUMS['='],
    type: getType(field),
    value: getValueField({ field }),
  }));

  if (payload.dateFrom || payload.dateTo) {
    const dateRules = [];

    if (payload.dateFrom) {
      const fromDate = new Date(payload.dateFrom);

      if (isValid(fromDate)) {
        dateRules.push({
          type: FILTER_RULE_ENUMS.CompareDateRuleType,
          field: 'createdAt',
          operator: FILTER_OPERATOR_ENUMS['>='],
          value: computeValueByRuleType(
            FILTER_RULE_ENUMS.CompareDateRuleType,
            FILTER_FIELDS_TYPES.Date,
            fromDate.toISOString()
          ),
        });
      }
    }

    if (payload.dateTo) {
      const toDate = new Date(payload.dateTo);

      if (isValid(toDate)) {
        dateRules.push({
          type: FILTER_RULE_ENUMS.CompareDateRuleType,
          field: 'createdAt',
          operator: FILTER_OPERATOR_ENUMS['<='],
          value: computeValueByRuleType(
            FILTER_RULE_ENUMS.CompareDateRuleType,
            FILTER_FIELDS_TYPES.Date,
            toDate.toISOString()
          ),
        });
      }
    }

    if (dateRules.length > 0) {
      rules.push({
        type: FILTER_RULE_ENUMS.AndRuleType,
        field: null,
        operator: null,
        value: dateRules,
      });
    }
  }
  if (rules.length) {
    return {
      type: FILTER_RULE_ENUMS.AndRuleType,
      field: null,
      operator: null,
      value: rules,
    };
  }

  return {
    type: FILTER_RULE_ENUMS.EmptyRuleType,
  };
};

const handleContracts = (data = []) => {
  if (!data?.length > 0) {
    return [];
  }
  return data?.map((item) => {
    const { meta } = item;

    const createdAt = meta?.[CONTRACTS_FIELDS_MAPPER.createdAt.key];

    return {
      [CONTRACTS_FIELDS_MAPPER.id.key]:
        item?.[CONTRACTS_FIELDS_MAPPER.id.key] || '-',
      [CONTRACTS_FIELDS_MAPPER.name.key]:
        meta?.[CONTRACTS_FIELDS_MAPPER.name.key]?.trim() || '-',
      [CONTRACTS_FIELDS_MAPPER.status.key]:
        CONTRACTS_FIELDS_MAPPER.status.options?.find(
          (option) =>
            option?.value === meta?.[CONTRACTS_FIELDS_MAPPER.status.key]
        )?.text || '-',
      [CONTRACTS_FIELDS_MAPPER.subscriptionOwner.key]:
        meta?.[CONTRACTS_FIELDS_MAPPER.subscriptionOwner.key] || [],
      [CONTRACTS_FIELDS_MAPPER.subscriptionId.key]:
        meta?.[CONTRACTS_FIELDS_MAPPER.subscriptionId.key] || '-',
      [CONTRACTS_FIELDS_MAPPER.templateName.key]:
        meta?.[CONTRACTS_FIELDS_MAPPER.templateName.key] || '-',
      [CONTRACTS_FIELDS_MAPPER.createdAt.key]: createdAt
        ? formatDate(createdAt, CONTRACTS_DATE_FORMAT)
        : '-',
      timeAgo: createdAt ? timeFromNow(createdAt) : '-',
    };
  });
};

export { handleContracts };
